import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchVatPayment } from '../query-api'

export const useFetchVatPayment = (vatPaymentId?: string) => {
  const { data, isLoading } = useQuery(
    [QueryKeys.VatPayment, vatPaymentId],
    () => fetchVatPayment(vatPaymentId as string),
    { enabled: !!vatPaymentId },
  )

  return { vatPayment: data?.salesTaxPayment, isLoading }
}
